import React, { FunctionComponent } from 'react';
import Card from '@Components/Card/Card';
import useScreen from '@Utils/hooks/useScreen';
import { getResponsiveModalStyles } from '@Utils/layout/layoutSupport';
import { ModalContainer } from '@Components/Modal/subComponents/ModalContainer/ModalContiner.styled';
import { useLocation } from 'react-router-dom';

const PaymentSummaryAction: FunctionComponent<types.cards.IPaymentSummaryActionProps['params']> = ({
	exceptionDescription,
	tryAgainWithEditPaymentCard,
}) => {
	const { screenClass } = useScreen();
	const { search } = useLocation();

	return (
		<ModalContainer styles={getResponsiveModalStyles(screenClass)}>
			<Card<types.cards.IPaymentSummaryActionProps>
				params={{ exceptionDescription, tryAgainWithEditPaymentCard }}
				card="paymentSummaryAction"
				withoutContainer
			/>
		</ModalContainer>
	);
};

export default PaymentSummaryAction;
